import List from "@/components/list";
import Bus from "./Bus.js";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  function handleDelete({ row }) {
    Bus.$emit("deleteVersion", row);
  }
  // 编辑
  function handleUpdate({ row }) {
    Bus.$emit("updateVersion", row);
  }
  function upLine({ row }) {
    Bus.$emit("upLine", row);
  }
  function downLine({ row }) {
    Bus.$emit("downLine", row);
  }
  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      ["icon-edit", "编辑", () => handleUpdate(vo), "version:update"],
      ["icon-delete", "删除", () => handleDelete(vo), "version:delete"]
    ];
    if (vo.row.versionState == 1) {
      dealConf.push([
        "icon-down",
        "取消发布",
        () => downLine(vo),
        "version:publish"
      ]);
    } else {
      dealConf.push(["icon-up", "发布", () => upLine(vo), "version:publish"]);
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "版本编号",
      prop: "versionCode",
      minWidth: "160",
      showOverflowTooltip: true
    },
    {
      label: "版本名称",
      prop: "versionName",
      minWidth: "130"
    },
    {
      label: "版本类型",
      prop: "versionTypeName",
      minWidth: "130"
    },
    {
      label: "发布状态",
      prop: "versionStateName",
      minWidth: "100"
    },
    {
      label: "自动升级",
      prop: "upgradeName",
      minWidth: "100"
    },
    {
      label: "创建人",
      prop: "createUserName",
      minWidth: "100"
    },
    {
      label: "操作",
      minWidth: "160",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
